import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import commonStore from "./stores/commonStore";

// api 호출 정의용
const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = "https://okr.luvd.co.kr/api"; // 본섭
// const API_ROOT = 'http://dev.fordate.org:8906/api'; // 윤진님섭
// 로컬 백엔드 테스트 주소
// const API_ROOT = "http://localhost:8906/api"; // 로컬 개발환경
// const API_ROOT = "http://localhost:8020"; // 형준 파이썬 로컬 개발환경

const PY_API_ROOT = "https://api.redate.co.kr/api"; // 운영 개발환경
// const PY_API_ROOT = "http://localhost:8020"; // 형준 파이썬 로컬 개발환경
// const PY_API_ROOT = "http://localhost:8000/api"; //파이썬 로컬환경

const PY_LOCAL_API_ROOT = "http://localhost:9562/api"; // 로컬 개발환경
// const PY_LOCAKL_API_ROOT = "http://localhost:8000/api"; // 형준 파이썬 로컬 개발환경

const handleErrors = (err) => {
  return err;
};

const responseBody = (res) => res.body;

// const tokenPlugin = (req) => {
//   if (commonStore.token) {
//     req.set("Authorization", `Bearer ${commonStore.token}`);
// };

const tokenPlugin = (req) => {
  // commonStore.token 값 출력
  console.log("Token 값:", commonStore.token);

  if (commonStore.token) {
    // 요청에 Authorization 헤더 설정
    req.set("Authorization", `Bearer ${commonStore.token}`);
    console.log("Authorization 헤더 설정됨:", `Bearer ${commonStore.token}`);
  } else {
    console.log("Authorization 헤더가 설정되지 않음: 값 없음");
  }

  // 설정된 모든 헤더 값을 출력 (req 객체가 이를 지원하는 경우)
  console.log("현재 요청의 헤더 값:", req.header);
};

const requests = {
  del: (url) => superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
  get: (url) => superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
  put: (url, body) => superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).end(handleErrors).then(responseBody),
  post: (url, body) => superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).end(handleErrors).then(responseBody),
};

const requests_py = {
  del: (url) => superagent.del(`${PY_API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
  get: (url) => superagent.get(`${PY_API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
  put: (url, body) => superagent.put(`${PY_API_ROOT}${url}`, body).use(tokenPlugin).end(handleErrors).then(responseBody),
  post: (url, body) => superagent.post(`${PY_API_ROOT}${url}`, body).use(tokenPlugin).end(handleErrors).then(responseBody),
};

const requests_py_local = {
  del: (url) => superagent.del(`${PY_LOCAL_API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
  get: (url) => superagent.get(`${PY_LOCAL_API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
  put: (url, body) => superagent.put(`${PY_LOCAL_API_ROOT}${url}`, body).use(tokenPlugin).end(handleErrors).then(responseBody),
  post: (url, body) => superagent.post(`${PY_LOCAL_API_ROOT}${url}`, body).use(tokenPlugin).end(handleErrors).then(responseBody),
};

const Auth = {
  login: (data) => requests.post("/login", data),
};

const Column = {
  create: (data) => requests.post("/column", data),
  getAll: () => requests.get("/column"),
  getAllPage: (num) => requests.get(`/column/page/${num}`),
  getMyPage: (num) => requests.get(`/column/my/page/${num}`),
  getPage: (category, num) => requests.get(`/column/category/${category}/page/${num}`),
  getDetail: (column_id) => requests.get(`/column/${column_id}`),
  edit: (data, column_id) => requests.put(`/column/${column_id}`, data),
  upload: (column_id, type) => requests.post(`/column/${column_id}/upload/${type}`), // 리데이트 칼럼에 업로드
  delete: (column_id) => requests.del(`/column/${column_id}`),
};

/** 워드프레스 관련 */
const Wordpress = {
  // 워드프레스에 게시글 업로드하기
  relove_upload: (column_id, body) => requests.post(`/wordpress/${column_id}/upload/relove`, body),
  reuniondate_upload: (column_id, body) => requests.post(`/wordpress/${column_id}/upload/reuniondate`, body),
  reunionlove_upload: (column_id, body) => requests.post(`/wordpress/${column_id}/upload/reunionlove`, body),

  // 게시글 업로드시, 진행도 업로드 완료(5)로 변경하기
  status_update: (column_id, body) => requests.put(`/wordpress/${column_id}/status`, body),

  // 테스트용
  test_upload: (column_id, body) => requests.post(`/wordpress/${column_id}/upload/test`),
  test_image_create: () => requests_py.get(`/column-admin`),

  // 배포용
  chatgpt: (body) => requests_py.post(`/column-admin/chatgpt`, body),
  dalle: (body) => requests_py.post(`/column-admin/dalle`, body),
  stablediffusion: (body) => requests_py.post(`/column-admin/stable`, body),

  // 카테고리 조회
  getTags: (domain) => requests.get(`/wordpress/tags/${domain}`),
  getCategories: (domain) => requests.get(`/wordpress/categories/${domain}`),

  // 워드프레스 칼럼 상태 변경 - 파이썬으로 다시제작
  state_update_py: (column_id, state_value) => requests_py.put(`/column-admin/${column_id}/state/${state_value}`),
};

// 파이썬으로 작성한 api 목록
const Python_API = {
  // 로컬용
  // chatgpt: (body)=>
  // requests_py_local.post(`/column-admin/chatgpt`, body),
  // dalle: (body)=>
  // requests_py_local.post(`/column-admin/dalle`, body),

  // 배포용
  chatgpt: (body) => requests_py.post(`/column-admin/chatgpt`, body),
  chatgpt_turbo: (body) => requests_py.post(`/column-admin/chatgpt/turbo`, body),
  dalle: (body) => requests_py.post(`/column-admin/dalle`, body),
  stablediffusion: (body) => requests_py.post(`/column-admin/stable`, body),
  image_merge: (body) => requests_py.post(`/column-admin/image/merge`, body),
  googletrans: (body) => requests_py.post(`/column-admin/googletrans`, body),
};

export default {
  Column,
  Auth,
  Wordpress,
  Python_API,
};
